import src from '../assets/perfectpargolfstudio.png';
import { imageLogo } from './imageLogo';

/**
 * Perfect Par Golf Studio — terracotta/copper square badge on transparency.
 * Drop the actual logo PNG at ../assets/perfectpargolfstudio.png (1024×1024).
 */
export const PerfectParGolfStudioLogo = imageLogo({
  src,
  width: 1024,
  height: 1024,
  alt: 'Perfect Par Golf Studio',
});
